import React from 'react';
import type SearchConstituent from '@/types/api/SearchConstituent';
import { formatDate } from '@/utils/dates';

function ConstituentLastInteraction({
  constituent,
}: {
  constituent: SearchConstituent;
}) {
  const { lastInteractionDate } = constituent;

  if (!lastInteractionDate) return null;

  return <div>{formatDate(lastInteractionDate)}</div>;
}

export default ConstituentLastInteraction;
